export const BRAND = {
  "clientId": "cashEquivalent",
  "displayName": "Cash & Equivalent",
  "legalName": "Cash & Equivalent",
  "web": {
    "appTitle": "Cash & Equivalent",
    "loginTitle": "Login",
    "apiBaseUrl": "https://api.cash.misrutas.info/api",
    "publicUrl": "https://cash.misrutas.info",
    "primaryColor": "#0B5FFF",
    "secondaryColor": "#0F172A",
    "accentColor": "#14B8A6",
    "supportEmail": "soporte@cashEquivalent.com",
    "hideForbiddenActions": true,
    "showMenuIcons": false,
    "assetUrls": {
      "logoFull": "/brand/logo-full.png",
      "logoMark": "/brand/logo-mark.png",
      "favicon": "/favicon.ico",
      "appleTouchIcon": "/apple-touch-icon.png",
      "ogImage": "/og-image.png"
    }
  }
} as const;
